import type { IconData } from '@stacksjs/iconify-core'

export const tableSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M46.317 14.25a152 152 0 0 0-.36-6.114c-.268-3.288-2.805-5.825-6.093-6.092C36.593 1.778 31.402 1.5 24 1.5c-2.708 0-5.12.037-7.25.097V14.25zM8.136 2.044c1.364-.11 3.062-.224 5.114-.318V14.25H1.683c.101-2.507.233-4.535.361-6.114c.267-3.288 2.804-5.825 6.092-6.092m-6.092 37.82c-.128-1.58-.26-3.607-.36-6.114H13.25v12.524a146 146 0 0 1-5.114-.318c-3.288-.267-5.825-2.804-6.092-6.092M16.75 33.75v12.653c2.13.06 4.542.097 7.25.097c7.402 0 12.593-.278 15.864-.544c3.288-.267 5.825-2.804 6.092-6.092c.129-1.58.26-3.607.361-6.114zM46.5 24c0 2.293-.027 4.373-.071 6.25H16.75v-12.5h29.679c.044 1.877.071 3.957.071 6.25M1.571 17.75A263 263 0 0 0 1.5 24c0 2.293.027 4.373.071 6.25H13.25v-12.5z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default tableSolid
